<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CustomerService from '@/services/customer'

export default {
  page: {
    title: "Clientes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Clientes",
      customers: [],
      searchValue: '',
      selectedCustomer: {
        user: {},
      },

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,
      page: 1,

      fields: [
        { key: 'customer.name', sortable: false, label: 'Cliente' },
        { key: 'customer.document_number', sortable: false, label: 'CNPJ' },
        { key: 'customer.phone_number', sortable: false, label: 'Telefone' },
        { key: 'city', sortable: false, label: 'Cidade/UF' },
        { key: 'user', sortable: false, label: 'Usuário' },
        { key: 'created_at', sortable: false, label: 'Data Cadastro', formatter: (value) => {
          return this.$moment(value).format('DD/MM/YYYY HH:mm:ss');
        } },
        { key: 'confirmed', label: 'Status' },
        { key: 'actions', label: 'Ações', class: 'nowrap-col' }
      ],
    };
  },
  computed: {
    rows() {
      return this.customers.length;
    }
  },
  mounted() {
    this.load(1);
  },
  methods: {
    load(page, hideLoading = false) {
      this.page = page;

      let loader;
      if (!hideLoading) {
        loader = this.$loading.show();
      }

      CustomerService.getCustomerRequests(page, this.searchValue).then(res => {
        if (!hideLoading) {
          loader.hide();
        }

        this.customers = res.data.data;

        this.count = res.data.count;
        this.currentCount = res.data.currentCount;
        this.currentPage = res.data.currentPage;
        this.totalPages = res.data.totalPages;
        this.perPage = res.data.perPage;
        this.startIndex = res.data.startIndex;
        this.endIndex = res.data.endIndex;
      }).catch(() => {
        if (!hideLoading) {
          loader.hide();
        }
      })
    },
    search() {
      this.load(1);
    },
    onPageChange() {
      this.load(this.currentPage);
    },
    formatDate(date) {
      return this.$moment(date).format('DD/MM/YYYY');
    },
    confirm(item) {
      let loader = this.$loading.show();

      this.$bvModal.hide('modal-confirm');

      CustomerService.confirmRequest(item._id).then(() => {
        loader.hide();

        this.$toast.open('Cliente aprovado com sucesso');

        this.load(this.page, true);
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao confirmar');
        loader.hide();
      })
    },

    rejectUser(item) {
      let loader = this.$loading.show();

      this.$bvModal.hide('modal-confirm-reject');

      CustomerService.rejectRequest(item._id).then(() => {
        loader.hide();

        this.$toast.open('Cadastro de cliente rejeitado com sucesso');

        this.load(this.page, true);
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao rejeitar');
        loader.hide();
      })
    },

    blockUser(item) {
      let loader = this.$loading.show();

      this.$bvModal.hide('modal-confirm-block');

      CustomerService.blockCustomer(item._id).then(() => {
        loader.hide();

        this.$toast.open('Cliente bloqueado com sucesso');

        this.load(this.page, true);
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao bloquear');
        loader.hide();
      })
    },

    unblockUser(item) {
      let loader = this.$loading.show();

      this.$bvModal.hide('modal-confirm-unblock');

      CustomerService.unblockCustomer(item._id).then(() => {
        loader.hide();

        this.$toast.open('Cliente desbloqueado com sucesso');

        this.load(this.page, true);
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao desbloquear');
        loader.hide();
      })
    },

    selectCustomer(item, modal) {
      this.selectedCustomer = item;

      if (modal === 'confirm') {
        this.$bvModal.show('modal-confirm');
      } else if (modal === 'reject') {
        this.$bvModal.show('modal-confirm-reject');
      } else if (modal === 'block') {
        this.$bvModal.show('modal-confirm-block');
      } else if (modal === 'unblock') {
        this.$bvModal.show('modal-confirm-unblock');
      } else if (modal === 'recover-password') {
        this.selectedCustomer.email = item.user.email;
        this.selectedCustomer.userId = item.user._id;
        this.$bvModal.show('modal-recover-password');
      }
    },

    showPassword(item) {
      this.selectedCustomer = item;
      this.$bvModal.show('modal-temp-password');
    },

    recoverPassword(item) {
      let loader = this.$loading.show();

      this.$bvModal.hide('modal-recover-password');

      CustomerService.recoverPassword(item.userId, item.email).then(() => {
        loader.hide();

        this.$toast.open('Recuperação de senha enviada');

        this.load(this.page, true);
      }).catch(() => {
        this.$toast.error('Ocorreu um erro');
        loader.hide();
      })
    },
    exportData() {
      let loader = this.$loading.show();

      CustomerService.downloadCustomerRequests(this.searchValue).then(res => {
        loader.hide();

        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', `lista-clientes.csv`);
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        loader.hide();
      })
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-6">
                <div class="position-relative search-input search-box">
                  <form @submit.prevent="search" class="align-items-center">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchValue"
                      placeholder="Procurar por nome..."
                    />

                    <button type="submit" class="btn btn-rounded btn-outline-primary ml-2">
                      Pesquisar
                    </button>
                  </form>
                </div>
              </div>

              <div class="col-6 text-right">
                <button class="btn btn-rounded btn-outline-secondary" @click="exportData">
                  Exportar Dados
                </button>
              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="customers"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template v-slot:cell(user)="row">
                  <p class="mb-0">{{row.item.user.name}}</p>
                  <p class="text-muted mt-0 font-size-11">{{row.item.user.email}}</p>
                </template>

                <template v-slot:cell(city)="row">
                  <p class="mb-0">{{row.item.city}}/{{row.item.state}}</p>
                </template>

                <template v-slot:cell(actions)="row">
                  <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                    <template v-slot:button-content>
                      <i class="mdi mdi-dots-horizontal font-size-18"></i>
                    </template>

                    <router-link class="dropdown-item" :to="'/customers/' + row.item.customer._id">
                      <i class="fas fa-pencil-alt text-success mr-2 mt-2"></i> Editar Dados do Cliente
                    </router-link>

                    <b-dropdown-item @click="selectCustomer(row.item, 'confirm')" v-if="!row.item.confirmed">
                      <i class="fas fa-check text-success mr-2 mt-2"></i> Aprovar Acesso
                    </b-dropdown-item>

                    <b-dropdown-item @click="selectCustomer(row.item, 'block')" v-if="row.item.confirmed && !row.item.blocked">
                      <i class="fas fa-ban text-danger mr-2 mt-2"></i> Bloquear Acesso
                    </b-dropdown-item>

                    <b-dropdown-item @click="selectCustomer(row.item, 'reject')" v-if="!row.item.confirmed && !row.item.rejected">
                      <i class="fas fa-ban text-danger mr-2 mt-2"></i> Recusar Acesso
                    </b-dropdown-item>

                    <b-dropdown-item @click="selectCustomer(row.item, 'unblock')" v-if="row.item.blocked">
                      <i class="fas fa-check text-success mr-2 mt-2"></i> Desbloquear Acesso
                    </b-dropdown-item>

                    <b-dropdown-item @click="showPassword(row.item)" v-if="row.item.user && row.item.user.temp_password">
                      <i class="fas fa-eye text-primary mr-2 mt-2"></i> Visualizar Senha Temporária
                    </b-dropdown-item>

                    <b-dropdown-item @click="selectCustomer(row.item, 'recover-password')" v-if="row.item.confirmed">
                      <i class="fas fa-unlock text-warning mr-2 mt-2"></i> Enviar Recuperação de Senha
                    </b-dropdown-item>
                  </b-dropdown>
                </template>

                <template v-slot:cell(confirmed)="row">
                  <span
                    class="badge badge-pill badge-soft-primary font-size-12"
                    :class=" {
                      'badge-soft-success': row.item.confirmed,
                      'badge-soft-warning': !row.item.confirmed,
                      'badge-soft-danger': row.item.blocked,
                      'badge-soft-danger': row.item.rejected,
                    }"
                  >{{row.item.blocked ? 'Bloqueado' : (row.item.confirmed ? 'Aprovado' :  (row.item.rejected ? 'Rejeitado' : 'Aguardando Aprovação'))}}</span>
                </template>
              </b-table>
            </div>
            
            <div class="row justify-content-md-between align-items-md-center mt-4">
              <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

              <div class="col-xl-5">
                <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                  <b-pagination
                    v-model="currentPage" 
                    :total-rows="count"
                    :per-page="perPage"
                    @input="onPageChange"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-confirm"
      title="Aprovar Cliente?"
      title-class="font-18"
      centered
    >
      <p>O acesso desse cliente será liberado. Deseja continuar?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-confirm')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="confirm(selectedCustomer)">Confirmar</b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modal-confirm-block"
      title="Bloquear Cliente?"
      title-class="font-18"
      centered
    >
      <p>O acesso desse cliente será bloqueado. Deseja continuar?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-confirm-block')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="danger" @click="blockUser(selectedCustomer)">Bloquear</b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modal-temp-password"
      title="Senha Temporária"
      title-class="font-18"
      centered
    >
      <p>{{selectedCustomer.user.temp_password}}</p>

      <div slot="modal-footer">
        <b-btn variant="primary" @click="$bvModal.hide('modal-temp-password')">Fechar</b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modal-confirm-reject"
      title="Recusar Cliente?"
      title-class="font-18"
      centered
    >
      <p>O cadastro do cliente será recusado. Deseja continuar?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-confirm-reject')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="danger" @click="rejectUser(selectedCustomer)">Recusar</b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modal-confirm-unblock"
      title="Desbloquear Cliente?"
      title-class="font-18"
      centered
    >
      <p>O acesso desse cliente será desbloqueado. Deseja continuar?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-confirm-unblock')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="unblockUser(selectedCustomer)">Desbloquear</b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modal-recover-password"
      title="Enviar Recuperação de Senha"
      title-class="font-18"
      centered
    >
      <p>Informe o e-mail para receber a solicitação de recuperação da senha</p>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <input
              id="email"
              name="email"
              type="email"
              class="form-control"
              v-model="selectedCustomer.email"
            />
          </div>
        </div>
      </div>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-recover-password')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="recoverPassword(selectedCustomer)">Confirmar</b-btn>
      </div>
    </b-modal>

  </Layout>
</template>

<style lang="scss">
  .search-box form {
    display: flex;
    flex-direction: row;
  }

  .search-box .form-control {
    padding-left: 20px;
  }

  .input-search {
    width: 90%;
  }
</style>